import axios from 'axios'
import { ROOT_PATH } from '../config'
import { TOKEN } from '../cache'
import auth from './auth';

export default function send (...value) {
  const FARMORG = auth.readCookie('FARMORG') ? (auth.readCookie('FARMORG') + '-0-0') : '';
  const ORGCODE = auth.readCookie('ORGCODE') || '';
  let config;
  if (typeof value[0] === 'string') {
    config = value[1] || {};
    config.url = value[0]
  }else {
    config = value[0]
  }
  let url = config.url;
  if (url.indexOf('http') !== 0) {
    url = ROOT_PATH + url
  }
  return axios({
    url,
    method: config.method || 'get',
    headers: {
      'x-http-appid': '1',
      'x-http-device': '0',
      'Content-Type': 'application/json',
      'Authorization': TOKEN,
      'farmorg': FARMORG,
      'orgcode': ORGCODE,
      ...config.header
    },
    data: config.data,
    params: config.params
  })
}
